// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2R0Xm","list":"BalanceDue_list__14z4f","listRow":"BalanceDue_listRow__OERQy","total":"BalanceDue_total__2gcvX"};